import { render } from "./BusinessCategory.vue?vue&type=template&id=1a417049&scoped=true"
import script from "./BusinessCategory.vue?vue&type=script&lang=js"
export * from "./BusinessCategory.vue?vue&type=script&lang=js"

import "./BusinessCategory.vue?vue&type=style&index=0&id=1a417049&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a417049"]])

export default __exports__